// v1.1: the Booths list's "where was I?" memory.
//
// Two DIFFERENT behaviours, deliberately (post-Trip-1 feedback):
//   - Tapping the bottom "Booths" tab is starting fresh    → top of the list.
//   - Coming back from a booth you just opened is resuming → same scroll offset,
//     same filter dropdowns, same search text.
//
// So the state is captured at the moment you TAP INTO a booth (before the list DOM
// is torn down) and consumed on the way back. The Booths tab clears it, which is
// what makes a tab entry read as "fresh" even when you were on a booth detail a
// second ago. In-memory only: a reload legitimately starts at the top.

export interface ListViewState {
  show: string;
  creator: string;
  priority: string;
  query: string;
  scrollY: number;
}

let entry: ListViewState | null = null;

/** Remember the list as it is right now (called when a booth row is tapped). */
export function saveListState(s: ListViewState): void {
  entry = s;
}

/** Peek at the remembered state; null when there's nothing to resume. */
export function getListState(): ListViewState | null {
  return entry;
}

/** Forget it — a fresh entry from the Booths tab, or a hard reset. */
export function clearListState(): void {
  entry = null;
}
